var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isUpdateNeeded)?_c('router-view'):_c('app-update-version')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }